<template>
  <div class="graderesult">
    <div v-if="detail" class="base">
      <!-- <van-nav-bar
        class="isccc mb-16"
        title="查看结果"
        left-arrow
        @click-left="onBack"
      /> -->
      <div
          class="container pl-16 pr-16 pb-80 pt-16"
      >
        <!-- resultType (integer, optional): 结果类型 0-普通成绩 1-合格证 , 2-科目成绩单 -->
        <!-- showStyle (integer, optional): 展示样式 1-显示名次 2-显示分数 3-分数/名次都显示 4-仅显示是否通过 , -->
        <!-- isUndecidedResult 是否未判定通过的成绩 0-否 1-是 , -->
        <!-- 1. 合格证11-->
        <template v-if="detail.resultType == 2">
          <div>
            <SubjectGradeCard :detail="detail"></SubjectGradeCard>
          </div>
          <div class="fixed-btn">
            <van-button
                v-if="detail.taskUrl && detail.formBtnName"
                @click="toFormTask"
                class="fb-btn"
                plain
                round
                block
                size="large"
                type="info"
            >
              {{ detail.formBtnName }}
            </van-button>
            <van-button
                class="fb-btn"
                @click="onDownload"
                round
                block
                size="large"
                color="linear-gradient(137deg, #00A7FF 0%, #0076FF 100%)"
            >
              保存成绩单
            </van-button>
            <van-button class="fb-btn" v-if="detail.admissionBtnName" @click="toExcel" type="primary" round block size="large"
                        color="linear-gradient(137deg, #00A7FF 0%, #0076FF 100%)">
              {{ detail.admissionBtnName }}
            </van-button>
          </div>
        </template>
      </div>
    </div>
    <van-image-preview v-model="show" :images="images">
      <template v-slot:index>长按保存图片</template>
    </van-image-preview>
  </div>
</template>

<script>
import {Button, Icon, NavBar, Toast} from "vant";
import html2canvas from "html2canvas";
import SubjectGradeCard from "./components/subject-grade-card.vue";
import dayjs from "dayjs";
import {goFaceCompare, saveExamResultImage} from "@/utils/appMethod";
import ApiInfo from "@/apis/api-info";
// import * as _localStorage from '@/utils/storage'

export default {
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Icon.name]: Icon,
    SubjectGradeCard,
  },
  data() {
    return {
      dayjs,
      detail: null,
      detailCopy: {
        collegeId: "S0NdscHd99fa84e36384f8d9025d963c6484",
        collegeName: "星海音乐学院附属中等音乐院校",
        collegeLogoUrl:
            "https://zego-davinci-public.oss-cn-shanghai.aliyuncs.com/test/logo/S0NdscHd99fa84e36384f8d9025d963c6484/80CD522C2004E499DD1948A66B6BD247--6950C00F1B4C.jpeg",
        batchName: "11111",
        specialtyName: "音乐创作",
        branchName: null,
        isNormalBranch: 0,
        scoreText: "100",
        hasPass: 1,
        publishTime: "2022.05.10 18:29",
        showStyle: 3,
        examResultId: null,
        resultType: 1,
        resultNote: "",
        rank: "第1名",
        isUndecidedResult: 0,
        certificateExtraContent: "",
        isNeedVoluntaryForm: 0,
        taskUrl: null,
        fillMode: null,
        resultTitle: "测试字段自定义",
        qrCode: null,
        formBtnName: null,
        linkUrl: null,
        officialPhoto: null,
        examineeNo: "18420104130321",
        examineeName: "柳友仁",
        examineeIdNo: "42070319930504639X",
        examineeSex: 1,
        userAccount: "632537786@qq.com",
        areaCode: "810000",
        areaName: "香港特别行政区",
        guideBranchName: null,
        guideSpecialtyName: "音乐创作",
        jsonMap: {
          "2011": "12312312312312312312313123",
          "2002": "112",
          "2033": "112",
          "1011": "112",
          "1002": "112",
          "1004": "1993524684255",
          "1003": "1993524684255",
          "3001": "112",
          "3002": "112",
          "3013": "12312312222222222222222123123123123",
        },
        examResultSubjectReportCardInfoJson: {
          guideInfoList: [
            {
              code: 201,
              index: 1,
              name: "专业1",
            },
            {
              code: 200,
              index: 2,
              name: "专业23",
            },
            {
              code: 203,
              index: 3,
              name: "专业223",
            },
          ],
          personInfoList: [
            {
              code: 101,
              index: 1,
              name: "身份证",
            },
            {
              code: 100,
              index: 2,
              name: "身份证2",
            },
            {
              code: 100,
              index: 3,
              name: "身份证2",
            },
            {
              code: 100,
              index: 4,
              name: "身份证2",
            },
          ],
          resultInfoList: [
            {
              code: 300,
              index: 1,
              name: "subject11",
              weight: 20,
            },
            {
              code: 300,
              index: 2,
              name: "subject22subject22subject22subject22subject22subject22subject22",
              weight: 30,
            },
            {
              code: 301,
              index: 3,
              name: "subject33",
              weight: 50,
            },
          ],
        },
      },
      show: false,
      images: [],
      index: 0,
    };
  },
  async created() {
    await this.getSubjectDetail();
    // this.detail = this.detailCopy
    document.title = this.detail.resultTitle || `查看成绩`;
    this.formatText();
  },
  methods: {
    async getSubjectDetail() {
      const {examineeListId, token} = this.$route.query;
      const param = {examineeListId, headers: {token}};
      const res = await ApiInfo.POSTresultSubject(param);
      if (res && res.data) {
        this.detail = res.data
      } else {
        this.detail = null
        Toast('暂无数据')
      }
    },
    toFormTask() {
      window.location.href = this.detail.taskUrl
    },
    toExcel() {
      // 判断detail.admissionViewStartTime的时间是否大于当前时间，是则提示
      const admissionViewStartTime = this.detail.admissionViewStartTime
      const admissionViewEndTime = this.detail.admissionViewEndTime
      if (admissionViewStartTime && admissionViewEndTime) {
        const start = dayjs(admissionViewStartTime).format('YYYY-MM-DD HH:mm')
        const end = dayjs(admissionViewEndTime).format('YYYY-MM-DD HH:mm')
        if (admissionViewStartTime > new Date().getTime() || admissionViewEndTime < new Date().getTime()) {
          return Toast(`请在${start} - ${end}查看`)
        }
      } else if (admissionViewStartTime) {
        const start = dayjs(admissionViewStartTime).format('YYYY-MM-DD HH:mm')
        if (admissionViewStartTime > new Date().getTime()) {
          return Toast(`请在${start}之后查看`)
        }
      } else if (admissionViewEndTime) {
        const end = dayjs(admissionViewEndTime).format('YYYY-MM-DD HH:mm')
        if (admissionViewEndTime < new Date().getTime()) {
          return Toast(`请在${end}之前查看`)
        }
      }
      let url = this.getParentUrl()
      if (!(/android/i.test(navigator.userAgent) || /ios|iphone|ipod|pad/i.test(navigator.userAgent)) || (url && (url.indexOf("davinci-test-foreign-h5.zego.im") > -1 || url.indexOf("mobile.xiaoyibang.com") > -1))) {
        return Toast('请在小艺帮APP上查看！')
      } else {
        console.log('go APP');
        goFaceCompare()
      }
    },
    onBack() {
      this.$router.back();
    },
    formatText() {
      // if (this.detail.isUndecidedResult == 1) {
      //   this.detail.title = "考试结果";
      //   this.detail.message = `您的考试分数如下：${this.detail.specialtyName}: ${this.detail.scoreText}分`;
      // } else {
      //   if (this.detail.hasPass == 1) {
      //     this.detail.title = "恭喜您通过考试";
      //     this.detail.message = `恭喜您成绩合格，通过我校${this.detail.specialtyName}专业考试。`;
      //   } else {
      //     this.detail.title = "抱歉，您未通过考试";
      //     this.detail.message = `很遗憾您的成绩不合格，未通过我校${this.detail.specialtyName}专业考试。`;
      //   }
      // }
    },
    async convertToImage(container, options = {}) {
      // 生成快照
      // 设置放大倍数
      const scale = window.devicePixelRatio > 2 ? window.devicePixelRatio : 2;
      // 传入节点原始宽高
      const width = container.offsetWidth;
      const height = container.offsetHeight;
      // html2canvas配置项
      const ops = {
        scale,
        width,
        height,
        useCORS: true,
        allowTaint: false,
        ...options,
      };
      return html2canvas(container, ops).then((canvas) => {
        // 返回图片的二进制数据
        return canvas.toDataURL("image/png");
      });
      // 调用函数，取到截图的二进制数据，对图片进行处理（保存本地、展示等）
      // const imgBlobData = await convertToImage(element)
    },
    dataURLToBlob(dataurl) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = window.atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {type: mime});
    },
    async onDownload() {
      // platform 默认没有就是APP，有参数，根据参数来判断
      const {platform} = this.$route.query;
      const element = document.querySelector("#gradecard");
      const imgBlobData = await this.convertToImage(element);
      let url = this.getParentUrl()
      if (url && (url.indexOf("davinci-test-foreign-h5.zego.im") > -1 || url.indexOf("mobile.xiaoyibang.com") > -1)) {
        await this.onDownload_h5()
      } else if (!platform) {
        saveExamResultImage(imgBlobData.split(",")[1]);
      } else {
        let a = document.createElement("a");
        a.style.display = "none";
        const blob = window.URL.createObjectURL(
            this.dataURLToBlob(imgBlobData)
        );
        a.setAttribute("href", blob);
        a.setAttribute("download", "成绩结果.png");
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(blob);
        document.body.removeChild(a);
      }
    },
    getParentUrl() {
      let url = null;
      if (parent !== window) {
        try {
          url = parent.location.href;
        } catch (e) {
          url = document.referrer;
        }
      }
      console.log(url);
      return url;
    },
    async onDownload_h5() {
      const element = document.getElementById('gradecard')
      const imgBlobData = await this.convertToImage(element)
      this.images = [imgBlobData]
      this.show = true
    },
  },
};
</script>

<style lang="less" scoped>
.graderesult {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-size: cover;
  background-color: rgba(0, 118, 255, 0.04);
  background-repeat: no-repeat;
  background-position: center;
}

.base {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  z-index: 1;
}

.container {
  width: 100%;
  height: calc(100vh - 46px);
  overflow: auto;
}

.r-content {
  width: 100%;
  height: 100%;
  background: #fff;
  box-shadow: 0px 8px 16px rgba(39, 3, 27, 0.24);
  border-radius: 8px;
}

.isccc /deep/ .van-icon {
  color: #323233;
}

.grade {
  width: 640px;
  // height: 592px;
  background: #f8f8f8;
  border-radius: 4px;
  padding: 32px;
}

.gt-title {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  line-height: 35px;
  color: #666666;
  text-align: center;
}

.gt-text {
  word-break: break-all;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 26px;
  color: #001236;
}

.isnoneimg {
  width: 245px;
  height: 170px;
  /* margin-bottom: 30px/2; */
}

.fixed-btn {
  position: fixed;
  width: calc(100vw - 32px);
  bottom: 32px;
  left: 16px;
  z-index: 1000;
  display: flex;
  justify-content: space-evenly;
}

.fb-btn {
  margin: 0 10px;
}
</style>
